import React, { useState } from "react";

// Helper to convert Decimal to float if needed
const toNumber = (val) => {
    if (val && typeof val === "object" && val.constructor.name === "Decimal") {
        return parseFloat(val.toString());
    }
    return val ?? 0;
};

const formatNumber = (val) => {
    const num = typeof val === "object" && val?.constructor?.name === "Decimal" 
        ? parseFloat(val.toString()) 
        : Number(val ?? 0);
    return num.toLocaleString();
};

const RiskWidget = ({ data }) => {
    const [expandedId, setExpandedId] = useState(null);
    
    if (!data || data.length === 0) {
        return (
            <div className="loading-container">
                <span className="loading-text">Loading data</span>
                <span className="loading-dots">
                    <span></span><span></span><span></span>
                </span>
            </div>
        );
    } else {

        const handleRowClick = (id) => {
            setExpandedId(expandedId === id ? null : id);
        };
        // Sort data by risk_week descending
        const sortedData = [...data].sort(
            (a, b) => parseFloat(toNumber(b.risk_week)) - parseFloat(toNumber(a.risk_week))
        );

        return (
            <div
                style={{
                    maxHeight: "333px",
                    overflowY: "auto",
                    border: "1px solid #444",
                    borderRadius: "6px",
                    padding: "12px",
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "#0f172a", // dark background
                }}
            >
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                        <tr style={{ textAlign: "left" }}>
                            <th style={{ padding: "8px", color: "#ffffff", backgroundColor: "transparent" }}>Asset</th>
                            <th style={{ padding: "8px", color: "#ffffff", backgroundColor: "transparent" }}>Group</th>
                            <th style={{ padding: "8px", color: "#ffffff", backgroundColor: "transparent" }}>Risk Today</th>
                            <th style={{ padding: "8px", color: "#ffffff", backgroundColor: "transparent" }}>Risk Week</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((item) => {
                            const riskToday = toNumber(item.risk_today);
                            const riskWeek = toNumber(item.risk_week);

                            const riskTodayColor =
                                riskToday > 20
                                    ? "#E94E77"
                                    : riskToday > 5
                                        ? "#F5A623"
                                        : "#4A90E2";

                            const riskWeekColor =
                                riskWeek > 20 ? "#E94E77" : riskWeek > 5 ? "#F5A623" : "#50E3C2";

                            const isExpanded = expandedId === item.id;

                            return (
                                <React.Fragment key={item.id}>
                                    <tr
                                        onClick={() => handleRowClick(item.id)}
                                        onMouseEnter={(e) => e.currentTarget.style.color = "#a0a09d"}
                                        onMouseLeave={(e) => e.currentTarget.style.color = "#f5f5dc"}
                                        style={{
                                            cursor: "pointer",
                                            borderBottom: "1px solid #444",
                                            // color: "#f5f5dc", // cream color
                                            backgroundColor: "transparent",
                                        }}
                                    >
                                        <td style={{ padding: "8px", fontWeight: "bold" }}>
                                            {item.lastname}
                                        </td>
                                        <td style={{ padding: "8px" }}>{item.group_name}</td>
                                        <td style={{ padding: "8px", color: riskTodayColor }}>
                                            {riskToday.toFixed(2)}
                                        </td>
                                        <td style={{ padding: "8px", color: riskWeekColor }}>
                                            {riskWeek.toFixed(2)}
                                        </td>
                                    </tr>

                                    {isExpanded && (
                                        <tr>
                                            <td colSpan={4} style={{ padding: "12px 16px", backgroundColor: "#1e1e1e" }}>
                                                <div style={{ display: "flex", flexWrap: "wrap", gap: "24px", color: "#f5f5dc" }}>
                                                    {/* Comments */}
                                                    <div>
                                                        <h4 style={{ margin: "0 0 4px 0", color: "#ffffff" }}>Comments</h4>
                                                        <div>Today: {formatNumber(item.comments_today).toLocaleString()}</div>
                                                        <div>Last Week: {formatNumber(item.comments_last_week).toLocaleString()}</div>
                                                        <div>All Time: {formatNumber(item.comments_all_time).toLocaleString()}</div>
                                                    </div>
                                                    {/* threats */}
                                                    <div>
                                                        <h4 style={{ margin: "0 0 4px 0", color: "#ffffff" }}>Threats</h4>
                                                        <div>Today: {formatNumber(item.threats_today).toLocaleString()}</div>
                                                        <div>Last Week: {formatNumber(item.threats_last_week).toLocaleString()}</div>
                                                        <div>All Time: {formatNumber(item.threats_all_time).toLocaleString()}</div>
                                                    </div>
                                                    {/* articles */}
                                                    <div>
                                                        <h4 style={{ margin: "0 0 4px 0", color: "#ffffff" }}>Articles</h4>
                                                        <div>Today: {formatNumber(item.articles_today).toLocaleString()}</div>
                                                        <div>Last Week: {formatNumber(item.articles_last_week).toLocaleString()}</div>
                                                    </div>

                                                    {/* Risk */}
                                                    <div>
                                                        <h4 style={{ margin: "0 0 4px 0", color: "#ffffff" }}>Risk</h4>
                                                        <div>
                                                            Today:{" "}
                                                            <span style={{ color: riskTodayColor }}>{riskToday.toFixed(2)}</span>
                                                        </div>
                                                        <div>
                                                            This Week:{" "}
                                                            <span style={{ color: riskWeekColor }}>{riskWeek.toFixed(2)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
};

export default RiskWidget;
